import { c as _c } from "react/compiler-runtime";
import { css } from '@repo/pandacss/css';
import { MaskIcon } from '@repo/ui/primitives/MaskIcon';
const iconWrapper = css({
  display: 'flex',
  px: '[2px]'
});
export const ListIconFilled = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <span className={iconWrapper} data-testid="rewards-breakdown-icon"><MaskIcon glyph="list-filled" css={{
        boxSize: "[20px]",
        color: "common.black"
      }} /></span>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export const CreditCardIconFilled = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <span className={iconWrapper} data-testid="card-details-icon"><MaskIcon glyph="credit-card" css={{
        boxSize: "[20px]",
        color: "common.black"
      }} /></span>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export const NWIcon = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <span className={iconWrapper} data-testid="nw-take-icon"><MaskIcon glyph="nw" css={{
        boxSize: "icon.small",
        color: "common.black"
      }} /></span>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};